
import { ModelBase } from '../../abstract/model-base.model';
import { PaymentInstallment } from './installment.model';

export class PaymentSchedule extends ModelBase {

    static override CLASS_NAME: string = 'PaymentSchedule';

    private _installments!: PaymentInstallment[];
    private _label!: string;

    constructor(data?: any) {
        super(data);
        this.installments = this._installments || [];
    }

    public get installments(): PaymentInstallment[] {
        return this._installments;
    }

    public set installments(value: PaymentInstallment[]) {
        this._setValue('_installments', value, 'PaymentInstallment');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

}
